import { DATA_SOURCES } from '@/config/constants';
import RelatedBrandsSectionShell from '../RelatedCategoriesTable/RelatedBrandsSectionShell';

function InstagramRelatedBrandsSectionTable(props) {
    return (
        <RelatedBrandsSectionShell {...props} source={DATA_SOURCES.INSTAGRAM} />
    );
}

export default InstagramRelatedBrandsSectionTable;
